<template>
  <er-card v-loading="loading">
    <layout-toolbar slot="header" type="flex" justify="space-between">
      <p class="card-title">{{ `${$t("Comn_manual_feed")}` }}</p>
      <el-col :span="10" :md="10" :lg="9" :xl="8">
        <er-date-picker
          v-model="dateRange"
          :clearable="false"
          @change="handleValueChange"
        ></er-date-picker>
      </el-col>
    </layout-toolbar>
    <el-row :key="$i18n.locale">
      <high-charts
        :options="chartOptions"
        ref="highcharts"
        constructor-type="stockChart"
      ></high-charts>
    </el-row>
  </er-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import chartMixin from "@/mixins/chartMixin";
import { manualFeedGraph } from "./chartOptions";

export default {
  mixins: [errorHandlerMixin, chartMixin],
  data: function() {
    return {
      loading: false,
      dateRange: [],
      params: {
        from_date: "",
        to_date: "",
        month_of: null,
        week_of: null,
        get_all: true
      },
      newFeedRecord: {
        pond_id: "",
        date: "",
        feed_dispensed: 0,
        feed_id: "",
        modified: false
      },
      chartOptions: { ...manualFeedGraph },
      pondSlotFeedLogs: []
    };
  },
  computed: {
    ...mapGetters("pondDetails", {
      getPondScheduleGraphSlotWiseFeed: "getPondScheduleGraphSlotWiseFeed",
      getManualFeedData: "getManualFeedData"
    }),
    defaultMomentDtRangeForCurrCulture() {
      return this.getMomentObjArrOfCultureDateRange;
    }
  },
  methods: {
    ...mapActions("pondDetails", {
      fetchManualFeedData: "fetchManualFeedData"
    }),
    async initComponent(pondId) {
      this.loading = true;
      try {
        await this.fetchManualFeedData({
          deviceType: "pond",
          params: this.params
        });
        this.pondSlotFeedLogs = this.getManualFeedData;
        this.initAxisTextKeys("Comn_date", "Comn_feed_kg");
        this.initChartLang();
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    generateData() {
      const feedLimit = [];
      const dispensedLimit = [];
      let totalFeedLimit = [];
      let totalDispensedLimit = [];
      const startDate = this.$moment(this.dateRange[0]);
      const endDate = this.$moment(this.dateRange[0]);

      for (let i = 0; i < 10000; i++) {
        feedLimit.push({
          x: startDate.add(i, "seconds").toDate(),
          y: Math.random() * 1000
        });
        dispensedLimit.push({
          x: endDate.add(i, "seconds").toDate(),
          y: Math.random() * 1000
        });
      }
      totalFeedLimit = Object.values(feedLimit)
        .map(feed => feed.y)
        .reduce((acc, curr) => acc + curr);
      totalDispensedLimit = Object.values(dispensedLimit)
        .map(feed => feed.y)
        .reduce((acc, curr) => acc + curr);
      return { feedLimit, dispensedLimit, totalFeedLimit, totalDispensedLimit };
    },
    normalizeRecords(pondFeedDaysWise) {
      const manualFeedRecords = pondFeedDaysWise || [];
      return manualFeedRecords.reduce((acc, { pond_id, date, feeds }) => {
        const arrFeeds = feeds.map(({ feed_dispensed, feed_id }, index) => {
          const newFeedRecord = this.$lodash.cloneDeep(this.newFeedRecord);
          newFeedRecord.date = date;
          newFeedRecord.modified = false;
          newFeedRecord.pond_feed_index = index;
          newFeedRecord.feed_id = feed_id._id;
          newFeedRecord.feed_name = feed_id.feed_type
            ? `${feed_id.name}-${feed_id.feed_type}`
            : feed_id.name;
          newFeedRecord.feed_dispensed = feed_dispensed;
          return newFeedRecord;
        });
        acc.push(...arrFeeds);
        return acc;
      }, []);
    },
    pondFeedGroupByFeedName(pondFeedDaysWise, dateRange) {
      const dateToManualFeed = {};
      const dateToFeedName = {};
      const dayStart = moment(dateRange[0] + "T00:00:00.000Z");
      const dayEnd = moment(dateRange[1] + "T00:00:00.000Z");
      while (dayStart <= dayEnd) {
        dateToManualFeed[dayStart.valueOf()] = 0;
        dateToFeedName[dayStart.valueOf()] = "none";
        dayStart.add(1, "days");
      }
      const normalizeRecords = Object.values(
        this.normalizeRecords(pondFeedDaysWise)
      );
      normalizeRecords.forEach(dayFeed => {
        const date = moment(dayFeed.date);
        dateToManualFeed[date.valueOf()] = Number(
          dayFeed.feed_dispensed.toFixed(2)
        );
        dateToFeedName[date.valueOf()] = dayFeed.feed_name;
      });
      const groupByFeed = {};
      Object.keys(dateToManualFeed).forEach(key => {
        if (dateToFeedName[key] !== "none") {
          if (groupByFeed[dateToFeedName[key]] === undefined) {
            groupByFeed[dateToFeedName[key]] = [];
          }
          groupByFeed[dateToFeedName[key]].push({
            x: Number(key),
            y: dateToManualFeed[key]
          });
        }
      });
      Object.values(groupByFeed).forEach(FeedTypeManualFeed => {
        FeedTypeManualFeed = FeedTypeManualFeed.sort((a, b) => a.x - b.x);
      });
      return { groupByFeed };
    },
    initChart() {
      let result = {};
      let feedLimit = [];
      if (this.pondSlotFeedLogs.length === 0) {
        /* let x = this.generateData(
        //   feedLimit,
        //   dispensedLimit,
        //   totalFeedLimit,
        //   totalDispensedLimit
        // );
        // feedLimit = x.feedLimit;
        // dispensedLimit = x.dispensedLimit;
        // totalFeedLimit = Object.values(feedLimit)
        //   .map(feed => feed.y)
        //   .reduce((acc, curr) => acc + curr);
        // totalDispensedLimit = Object.values(dispensedLimit)
        //   .map(feed => feed.y)
          .reduce((acc, curr) => acc + curr); */
        this.chartOptions.series = [];
        return;
      } else {
        result = this.pondFeedGroupByFeedName(this.pondSlotFeedLogs, [
          this.params.from_date,
          this.params.to_date
        ]);
        feedLimit = result.groupByFeed;
      }
      this.initChartSeries(feedLimit);
    },
    initChartSeries(feedLimit) {
      this.chartOptions.series = [];
      const arrFeedTypes = Object.keys(feedLimit);
      const noOfFeedTypes = arrFeedTypes.length;
      const feedColors = this.getNColors(noOfFeedTypes);
      arrFeedTypes.forEach((feedType, index) => {
        this.chartOptions.series.push({
          name: feedType,
          data: feedLimit[feedType],
          type: "line",
          color: feedColors[index],
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, "rgba(124, 181, 236,1)"],
              [1, "rgba(255,255,255,.25)"]
            ]
          },
          visible: true
        });
      });
    },
    async handleValueChange(currentSelectedValues) {
      let from_date = this.$moment(currentSelectedValues[0]);
      let to_date = this.$moment(currentSelectedValues[1]);
      if (!this.checkDateWithInCultureRange(from_date)) {
        from_date = this.getMomentObjArrOfCultureDateRange[0];
      }
      if (!this.checkDateWithInCultureRange(to_date)) {
        to_date = this.getMomentObjArrOfCultureDateRange[1];
      }
      this.params.from_date = from_date.format("YYYY-MM-DD");
      this.params.to_date = to_date.format("YYYY-MM-DD");
      await this.initComponent(this.pondId);
    },
    getNColors(numOfColors) {
      const arrColors = [];
      const initL = (100 - 20) / numOfColors;
      const initH = (360 - 60) / numOfColors;
      for (let i = 1; i <= numOfColors; i++) {
        arrColors.push(this.hsl2rgb(initH * i, 96 * 0.01, initL * i * 0.01));
      }
      return arrColors;
    },
    hsl2rgb(h, s, l) {
      const a = s * Math.min(l, 1 - l);
      const f = (n, k = (n + h / 30) % 12) =>
        l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return this.rgbToHex(f(0), f(8), f(4));
    },
    rgbToHex(r, g, b) {
      return (
        "#" +
        [r, g, b]
          .map(x =>
            Math.round(x * 255)
              .toString(16)
              .padStart(2, 0)
          )
          .join("")
      );
    }
  }
};
</script>
<style lang="scss"></style>
